<template>
  <CustomCreateDialog
    noCloseOnBackdrop
    dialogTitle="ایجاد بخش جدید برای منبع"
    dialogId="create-resource-content-section-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendCreateResourceContentSectionRequest"
  >
    <BCol cols="12">
      <TextInput
        customRules="required|min:1"
        inputId="resource-content-title"
        inputLabel="عنوان بخش"
        inputPlaceholder="گرامر..."
        v-model="resourceContentSectionPayload.title"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <BFormGroup label="توضحیات بخش" label-for="resource-content-desc">
        <BFormTextarea
          rows="5"
          v-model="resourceContentSectionPayload.description"
          size="sm"
          id="resource-content-desc"
          placeholder="منابع مورد نیاز برای گرامر..."
        ></BFormTextarea>
      </BFormGroup>
    </BCol>
    <BCol cols="12">
      <BFormGroup
        label="تصویر اصلی بخش"
        label-for="resourceContentSectionImageFile"
      >
        <BFormFile
          v-model="resourceContentSectionPayload.imageFile"
          ref="resourceContentSectionImageFile"
          id="resourceContentSectionImageFile"
          accept="image/*"
          @input="handleImageFile"
        ></BFormFile>
      </BFormGroup>
    </BCol>
    <BCol
      cols="12"
      class="position-relative"
      v-if="resourceContentSectionPayload.imageFile"
    >
      <BImg
        rounded
        class="custom-image"
        center
        fluid
        :src="resourceContentSectionimagePreview"
      ></BImg>

      <BButton
        size="sm"
        variant="transparent"
        class="custom-delete-btn"
        @click="deletePreviewImage"
      >
        <FeatherIcon size="40" class="text-danger" icon="Trash2Icon" />
      </BButton>
    </BCol>
    <BCol cols="12">
      <hr />
    </BCol>

    <BCol
      cols="12"
      v-for="(item, index) in resourceContentSectionPayload.attachments"
      :key="index"
    >
      <BRow>
        <BCol cols="12" class="py-0 my-0">
          <div class="w-100 d-flex align-items-center justify-content-between">
            <p style="font-size: 12px">فایل {{ index + 1 }}</p>
            <BButton
              size="sm"
              variant="danger"
              @click="removeAttachment(index)"
            >
              حذف فایل
            </BButton>
          </div>
        </BCol>
        <BCol cols="12">
          <ResourceAttachmentTypePicker
            :defaultSelectedType="item.resourceDetailAttachmentType"
            v-model="item.resourceDetailAttachmentType"
          ></ResourceAttachmentTypePicker>
        </BCol>
        <BCol cols="12">
          <BFormGroup label="فایل" :label-for="`imageFile${index}`">
            <BFormFile
              v-model="item.imageFile"
              ref="imageFile"
              :id="`imageFile${index}`"
              :accept="
                attachmentTypeMimeTypes[item.resourceDetailAttachmentType]
              "
            ></BFormFile>
          </BFormGroup>
        </BCol>
      </BRow>
    </BCol>
    <BCol cols="12" v-if="uploaded">
      <p class="mb-0">در حال آپلود {{ uploaded + "%" }}</p>
      <b-progress animated v-model="uploaded" max="100" />
    </BCol>
    <BCol cols="12">
      <BButton
        class="w-100 my-1"
        variant="primary"
        @click="addNewFileAttachment"
      >
        افزودن فایل
      </BButton>
    </BCol>
  </CustomCreateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    resourceDetailId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      uploaded: null, // Webservice fill this value with upload percentage automatically
      isOkButtonDisabled: false,
      resourceContentSectionPayload: {
        resourceDetailId: null,
        title: null,
        description: null,
        imageFile: null,
        attachments: [
          {
            resourceDetailAttachmentType: 1,
            imageFile: null,
          },
        ],
      },
      resourceContentSectionimagePreview: null,
      attachmentTypeMimeTypes: {
        1: ".jpg,.jpeg,.png",
        2: ".mp3,.wav",
        3: ".mp4,.mov",
        4: ".pdf",
      },
    };
  },
  methods: {
    handleImageFile() {
      if (
        this.resourceContentSectionPayload &&
        this.resourceContentSectionPayload.imageFile
      ) {
        this.resourceContentSectionimagePreview = URL.createObjectURL(
          this.resourceContentSectionPayload.imageFile
        );
      }
    },
    deletePreviewImage() {
      if (
        this.resourceContentSectionPayload &&
        this.resourceContentSectionPayload.imageFile
      ) {
        URL.revokeObjectURL(this.resourceContentSectionimagePreview);
        this.resourceContentSectionimagePreview = null;
        this.resourceContentSectionPayload.imageFile = null;
        if (
          this.$refs.resourceContentSectionImageFile &&
          this.$refs.resourceContentSectionImageFile
        ) {
          this.$refs.resourceContentSectionImageFile.reset();
        }
      }
    },
    removeAttachment(index) {
      this.resourceContentSectionPayload.attachments.splice(index, 1);
    },
    addNewFileAttachment() {
      this.resourceContentSectionPayload.attachments.push({
        resourceDetailAttachmentType: 1,
        imageFile: null,
      });
    },
    async sendCreateResourceContentSectionRequest() {
      try {
        this.isOkButtonDisabled = true;
        this.resourceContentSectionPayload.resourceDetailId =
          this.resourceDetailId;
        let _this = this;
        let createResourceDetailContent = new CreateResourceDetailContent(
          _this
        );
        createResourceDetailContent.setFormData(
          helper.generateFormData(_this.resourceContentSectionPayload)
        );
        await createResourceDetailContent.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.uploaded = null;
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "اضافه شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "بخش جدید با موفقیت به منبع شما اضافه شد.",
              },
            });
            _this.resourceContentSectionPayload = {
              resourceDetailId: null,
              title: null,
              description: null,
              attachments: [
                {
                  resourceDetailAttachmentType: 1,
                  imageFile: null,
                },
              ],
            };
            _this.$bvModal.hide("create-resource-content-section-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "اضافه نشد!",
                icon: "XIcon",
                variant: "danger",
                text:
                  res.data.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    ResourceAttachmentTypePicker,
    CustomCreateDialog,
    BFormTextarea,
    BFormGroup,
    TextInput,
    BFormFile,
    BProgress,
    BButton,
    BRow,
    BCol,
    BImg,
  },
};
import ResourceAttachmentTypePicker from "@/views/components/Resources/ResourceAttachmentTypePicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import helper from "@/libs/Helper";
import { CreateResourceDetailContent } from "@/libs/Api/Resources";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormFile,
  BFormTextarea,
  BButton,
  BImg,
  BProgress,
} from "bootstrap-vue";
</script>

<style scoped>
.custom-image {
  max-height: 200px;
}
</style>
